<template>  
<div> <!-- root element start -->
    <div  class="row" v-if="dataComp == 0">
      <div class="col-12 mt-4">
        <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
      </div>
    </div>
    <div v-if="dataComp == 1" class="row">
      <div class="col-12">
        <div class="card border-0">
          <div class="card-header bg-transparent border-0 d-flex justify-content-between align-items-center">
            <span class="h5">Quotes</span>
            <a href="#" @click="addQuote"><small class="">Add a Quote</small></a>
          </div>
          <div class="card-body">
              <v-client-table :data="data" :columns="tableColumns" :options="tableOptions">
                <div slot="price" slot-scope="props">
                  {{ props.row.build.build_price | currency }}
                </div>
                <div slot="contactName" slot-scope="props">
                  {{ props.row.contact.contact_f_name }} {{ props.row.contact.contact_l_name }}
                </div>
                <div slot="quoteView" slot-scope="props">
                  <a :href="detailUrl + props.row.id" target="_Blank" class="" ><i class="fa fa-file-pdf-o" aria-hidden="true"></i></a>
                </div>
                <div slot="quoteSelect" slot-scope="props">
                  <a href="#" class="" @click="viewQuote(props.row.id)"><i class="fa fa-search" aria-hidden="true"></i></a>
                </div>
              </v-client-table>
          </div>
        </div>
      </div>
    </div>


</div> <!-- root element end -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/org-main-store.js'


// import catMain from '../InstComponents/CategoryComponents/category-main.vue'


export default {
  store,
  data: function () {
    return { 
      detailUrl: '/utility/user/quote/viewquoteform/',
      tableColumns: ['id', 'build.build_name', 'contactName', 'price', 'created_at', 'quoteView', 'quoteSelect'],
      tableOptions: {
        skin: 'table table-sm border-0 vuetable2',
        filterable: false,
        pagination: { chunk:4 },
        perPageValues: [],
        perPage: 15,
        dateColumns: ['created_at'],
        dateFormat: 'MM-DD-YYYY',
        toMomentFormat:  'YYYY-MM-DD H:mm:ss',
        texts:{
          filter:"",
          count:"",
          filterPlaceholder:"Search",
          page:"Page:",
          noResults:"No Quotes Found",
          loading:'Loading...',
        },
        columnsClasses: {
          created_at: '',
          price: 'text-center',
          'build.product.name': '',
          Name: '',
          quoteView: 'text-center',
          quoteSelect: 'text-center',
        }, 
        headings: { 
          id: 'Ref',
          created_at: 'Date',
          'build.price': 'Quote Price',
          'build.build_name': 'Build',
          contactName: 'Contact',
          quoteView: '',
          quoteSelect: '',
        },
      }

    }
  },
  computed: {
    data () { return this.$store.state.orgQuotes },
    dataComp () { return this.$store.state.orgQuotesComp },
  },
  watch: {
    
  },
  mounted() {
    
  },
  methods: {
    changeRightView(name, prop1, prop2) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2 }); },
    addQuote(){
      var _this = this;
      _this.$emit('onSecComplete', ['launchAddQuote', 2])

    },
    viewQuote(x){
      var _this = this;
      _this.$emit('onSecComplete', ['quote-view', x])
    },
  },    
  components:{
    ScalingSquaresSpinner
  },
  filters: {

  }
}
</script>
